import type { IUser, IUserPreferences } from "src/model/model";

export const buildNextPreferences = (
  currentPrefs: IUserPreferences | string | undefined,
  want: boolean,
): IUserPreferences => {
  let base: IUserPreferences = {};
  try {
    if (typeof currentPrefs === "string") {
      base = (JSON.parse(currentPrefs) as IUserPreferences) ?? {};
    } else if (currentPrefs) {
      base = { ...currentPrefs };
    }
  } catch {
    base = {};
  }
  return { ...base, wantToReceiveEmailAboutReleases: !!want };
};

export const getReleaseOptIn = (u?: IUser): boolean => {
  const pref = u?.preferences;
  if (!pref) return false;
  try {
    const obj = typeof pref === "string" ? (JSON.parse(pref) as IUserPreferences) : pref;
    return !!obj?.wantToReceiveEmailAboutReleases;
  } catch {
    return false;
  }
};

export const getAnalyticsOptOut = (u?: IUser): boolean => {
  const pref = u?.preferences;
  if (!pref) return false;
  try {
    const obj = typeof pref === "string" ? (JSON.parse(pref) as IUserPreferences) : pref;
    return obj?.analytics_opt_out === true;
  } catch {
    return false;
  }
};
